import React from 'react';
import cn from 'classnames';
import { Price } from 'swag-client-common/utils/price';
export const PriceTooltip = ({
  classes,
  price,
  priceForEachLabel,
  oldSetupFee,
  setupFee,
  totalSharedSetupFee,
  setupFeeLabel,
  priceWithoutSetUpFee,
  isStandaloneItem = false,
  isSharedInBoxItem = false,
  isEditingSharedOrRelatedItem = false,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.tooltip,
  "data-block": "PriceTooltip"
}, /*#__PURE__*/React.createElement("div", {
  className: classes.title
}, "Total Cost"), /*#__PURE__*/React.createElement("div", {
  className: classes.divider
}), /*#__PURE__*/React.createElement("div", {
  className: classes.tooltipRow
}, /*#__PURE__*/React.createElement("div", {
  className: classes.label
}, priceForEachLabel), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.number, {
    [classes.orange]: isLimitedEdition
  }),
  "data-price": "EachItem"
}, Price.formatPrice(priceWithoutSetUpFee))), /*#__PURE__*/React.createElement("div", {
  className: classes.tooltipRow
}, /*#__PURE__*/React.createElement("div", {
  className: cn(classes.label, {
    [classes.sharedSetupFee]: isStandaloneItem || isSharedInBoxItem
  })
}, setupFeeLabel), !!oldSetupFee && /*#__PURE__*/React.createElement("div", {
  className: cn(classes.oldNumber, {
    [classes.orange]: isLimitedEdition
  }),
  "data-price": "OldSetupFee"
}, Price.formatPrice(oldSetupFee)), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.number, {
    [classes.orange]: isLimitedEdition
  }),
  "data-price": "SetupFee"
}, Price.formatPrice(setupFee))), /*#__PURE__*/React.createElement("div", {
  className: classes.tooltipInfo
}, getTooltipText({
  oldSetupFee,
  setupFee,
  isEditingSharedOrRelatedItem,
  totalSharedSetupFee
})), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.tooltipRow, classes.tooltipTotal)
}, /*#__PURE__*/React.createElement("div", {
  className: classes.label
}, "Total:"), /*#__PURE__*/React.createElement("div", {
  className: cn(classes.blueNumber, {
    [classes.orange]: isLimitedEdition
  }),
  "data-price": "Total"
}, Price.formatPrice(price))), /*#__PURE__*/React.createElement("div", {
  className: classes.hidePointer
}));
function getTooltipText({
  oldSetupFee,
  setupFee,
  totalSharedSetupFee,
  isEditingSharedOrRelatedItem
}) {
  const isSetupFeeWithoutDiscount = !oldSetupFee && setupFee > 0;
  const defaultText = 'In the future, if you reorder this product, your full setup fee for the item will be free.';
  if (isSetupFeeWithoutDiscount && isEditingSharedOrRelatedItem && totalSharedSetupFee) {
    return `
      This is a Shared Setup Fee for this item across your order. 
      The total setup fee is ${Price.formatPrice(totalSharedSetupFee)}, and the portion related to this part of your order is shown here. 
      ${defaultText}`;
  }
  if (isSetupFeeWithoutDiscount) {
    return defaultText;
  }
  return null;
}